<template>
  <div class="home">
    <section class="main_content">
      <div class="addToHome" v-if="hideAddtoHomeShowJSbridge">
        <div
          :class="hideAddtoHomeShowJSbridge ? 'addtohomescreen active_homescreen' : 'addtohomescreen'"
        >
          <div class="logo-imgbox">
            <img :src="addTohomeImage" alt="add-to-home" />
          </div>
          <div class="textbox" @click="JsBridgeOpenPrompt()">
            <span id="ad2hs-prompt">Add {{DukaanbusinessName.toLowerCase()}} to Home Screen</span>
          </div>
          <div class="close-prompt">
            <i class="material-icons" @click="JsBridgehideAddtoHome()">close</i>
          </div>
        </div>
      </div>

      <Category :categoriesName="categoryTreeResponse" />
      <BaseSlider />

      <CollectionProduct
        :dataValue="collectionList"
        :title="$t('collectionForYou')"
        :merchantId="MerchantId"
      />

      <ProductCard
        :dataValue="trendingProductList"
        :title="$t('trendingProd')"
        :merchantId="MerchantId"
        :getMyPrice="isMyPrice"
      />
      <div
        class="img_wrapper price_banner"
        v-if="bannerSaleOne"
        @click="goToGetProductByCategory(bannerSaleOne.id)"
      >
        <img :src="bannerSaleOne.bannerUrl" alt />
      </div>
      <ProductCard
        :dataValue="newCollectionList"
        :title="$t('newCollection')"
        :merchantId="MerchantId"
      />
      <div
        class="img_wrapper price_banner"
        v-if="bannerSaleTwo"
        @click="goToGetProductByCategory(bannerSaleTwo.id)"
      >
        <img :src="bannerSaleTwo.bannerUrl" alt />
      </div>

      <div v-for="(showAlternateData,index) in showAlternateDataList" :key="index">
        <div v-if="categoryTreeResponse.length > 0" class="alternateList">
          <CategoryCard
            v-if="showAlternateData.evenCategoryIndex <=categoryTreeResponse.length-1"
            :categoriesTree="categoryTreeResponse[showAlternateData.evenCategoryIndex]"
          />
          <div class="all_under_price" v-if="index==0">
            <ul>
              <li
                v-for="(product,index) in underPriceCategory1.merchandisePriceFilterDTOs"
                :key="index"
                @click="openUnderPriceList(product.merchandiseId)"
              >
                <img :src="product.imageUrl" alt="product-image" />
              </li>
            </ul>
          </div>
          <div class="all_under_price" v-if="index==2">
            <ul>
              <li
                v-for="(product,index) in underPriceCategory2.merchandisePriceFilterDTOs"
                :key="index"
                @click="openUnderPriceList(product.merchandiseId)"
              >
                <img :src="product.imageUrl" alt="product-image"  />
              </li>
            </ul>
          </div>
        </div>
        <div v-if="categoryTreeResponse.length > 0" class="alternateList">
          <CategoryCard
            v-if="showAlternateData.oddCategoryIndex <=categoryTreeResponse.length-1"
            :categoriesTree="categoryTreeResponse[showAlternateData.oddCategoryIndex]"
          />
        </div>
        <div v-if="bannerSaleResponse.length > 0" class="alternateList">
          <ShopNow
            v-if="showAlternateData.bannerIndex <=bannerSaleResponse.length-1"
            :bannerSale="bannerSaleResponse[showAlternateData.bannerIndex]"
          />
        </div>
      </div>
      <CategoriesProduct :categoriesProduct="categoriesProductResponses" />
    </section>
  </div>
</template>

<script>
import "../assets/css/home-style.scss";
import constant from "../utils/constant";
import FilterOption from "../components/HomeSection/FilterOption";
import BaseSlider from "../components/HomeSection/BaseSlider";
import Category from "../components/HomeSection/Category";
import ProductCard from "../components/HomeSection/ProductCard";
import CollectionProduct from "../components/HomeSection/CollectionProduct";
import ShopNow from "../components/HomeSection/ShopNow";
import CategoriesProduct from "../components/HomeSection/CategoriesProduct";
import CategoryCard from "../components/HomeSection/CategoryCard";
import AddToHome from "../components/AddToHome";
export default {
  name: "Home",
  components: {
    BaseSlider,
    Category,
    ProductCard,
    CollectionProduct,
    ShopNow,
    CategoriesProduct,
    FilterOption,
    AddToHome,
    CategoryCard
  },

  data() {
    return {
      underPriceCategory1: {},
      underPriceCategory2: {},
      bannerSaleResponse: [],
      categoriesProductResponses: [],
      categoryTreeResponse: [],
      bannerSaleOne: "",
      bannerSaleTwo: "",
      showAlternateDataList: [],
      searchTerm: "",
      trendingProductList: [],
      newCollectionList: [],
      collectionList: [],
      discountedTrendingProducts: [],
      categoryTree: [],
      trendingIndex: 0,
      MerchantId: "",
      addTohomeImage: require("../assets/images/mall91_icon.png"),
      dukaanUniqueId: false,
      DukaanbusinessName: "Mall91",
      hideAddtoHomeShowJSbridge: false,
      isMyPrice: false
    };
  },
  methods: {
    JsBridgehideAddtoHome() {
      this.hideAddtoHomeShowJSbridge = false;
    },
    JsBridgeOpenPrompt() {
      window.Cstmbeforeinstallprompt.preventDefault();
      window.Cstmbeforeinstallprompt.prompt();
      let _self = this;
      window.Cstmbeforeinstallprompt.userChoice.then(choice => {
        if (choice.outcome === "accepted") {
          _self.hideAddtoHomeShowJSbridge = false;
        } else if (choice.outcome === "dismissed") {
          _self.hideAddtoHomeShowJSbridge = false;
        }
        window.Cstmbeforeinstallprompt = null;
      });
    },
    openUnderPriceList(id) {
      this.$router.push("/merchandise-product-by-id/" + id);
    },
    getCategoriesProduct() {
      this.$store
        .dispatch({ type: "getProductType", payload: "CATALOGUE" })
        .then(data => {
          if (
            data.data.trendingProductDTOs &&
            data.data.trendingProductDTOs.length > 0
          ) {
            this.categoriesProductResponses = data.data.trendingProductDTOs;
            this.$store.commit("saveCategoriesProduct", {
              categoriesProductResponses: this.categoriesProductResponses,
              categoriesProductId: 0
            });
          }
          if (
            data.data.merchandiseProductDTOs &&
            data.data.merchandiseProductDTOs.length > 0
          ) {
            this.merchandiseProducts = data.data.merchandiseProductDTOs;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getBannerSale() {
      this.$store
        .dispatch({ type: "getMerchandiseHome", payload: false })
        .then(data => {
          this.bannerSaleOne = data.data.merchandiseBannerDTOs[0];
          this.$store.commit("saveNonCarousel1", {
            nonCarousel1: this.bannerSaleOne
          });
          this.bannerSaleTwo = data.data.merchandiseBannerDTOs[1];
          this.$store.commit("saveNonCarousel2", {
            nonCarousel2: this.bannerSaleTwo
          });
          this.bannerSaleResponse = data.data.merchandiseBannerDTOs.splice(2);
          this.$store.commit("saveNonCarouselBanner", {
            nonCarouselBanner: this.bannerSaleResponse
          });

          let categoryProduct =
            this.categoryTreeResponse.length % 2 == 0
              ? this.categoryTreeResponse.length / 2
              : this.categoryTreeResponse.length / 2 + 1;
          let bannerSale = this.bannerSaleResponse.length;
          this.showAlternateDataList = [];
          if (categoryProduct > bannerSale) {
            for (let i = 0; i < categoryProduct; i++) {
              this.showAlternateDataList.push({
                bannerIndex: i,
                evenCategoryIndex: i * 2,
                oddCategoryIndex: i * 2 + 1
              });
            }
          } else {
            for (let i = 0; i < bannerSale - 1; i++) {
              this.showAlternateDataList.push({
                bannerIndex: i,
                evenCategoryIndex: i * 2,
                oddCategoryIndex: i * 2 + 1
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getCategoriesTree() {
      this.loading = true;
      this.$store
        .dispatch({
          type: "getCatalogue"
        })
        .then(data => {
          this.loading = false;
          this.categoryTreeResponse = data.data.childCategories;
          this.$store.commit("saveCategoryTree", {
            categoryTree: this.categoryTreeResponse
          });
          let categoryProduct =
            this.categoryTreeResponse.length % 2 == 0
              ? this.categoryTreeResponse.length / 2
              : this.categoryTreeResponse.length / 2 + 1;
          let bannerSale = this.bannerSaleResponse.length;
          this.showAlternateDataList = [];
          if (categoryProduct > bannerSale) {
            for (let i = 0; i < categoryProduct; i++) {
              this.showAlternateDataList.push({
                bannerIndex: i,
                evenCategoryIndex: i * 2,
                oddCategoryIndex: i * 2 + 1
              });
            }
          } else {
            for (let i = 0; i < bannerSale - 1; i++) {
              this.showAlternateDataList.push({
                bannerIndex: i,
                evenCategoryIndex: i * 2,
                oddCategoryIndex: i * 2 + 1
              });
            }
          }
        })
        .catch(err => {
          this.loading = false;
        });
    },
    getTrendingProducts() {
      this.$store
        .dispatch({
          type: "getProductType",
          payload: "PRODUCT"
        })
        .then(data => {
          this.trendingProductList =
            data.data.merchandiseCarouselProductDTOs[0].merchandiseProductDTOs;
          this.$store.commit("saveTrendingProduct", {
            trendingProductList: this.trendingProductList,
            trendingProductId: 0
          });
          this.MerchantId =
            data.data.merchandiseCarouselProductDTOs[0].merchandiseId;
          this.$store.commit("merchantId", {
            merchantId: this.MerchantId
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    getUnderPriceCategory() {
      this.$store
        .dispatch({ type: "getProductType", payload: "PRICE" })
        .then(data => {
          this.underPriceCategory1 = data.data.merchandisePriceDTOs[0];
          this.underPriceCategory2 = data.data.merchandisePriceDTOs[1];
          this.$store.commit("saveUnderPriceCategory", {
            underPriceCategory: data.data.merchandisePriceDTOs
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    goToGetProductByCategory(merchandiseId) {
      this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
          window.location.reload();
        }
      });
      this.$router.push("/merchandise-product-by-id/" + merchandiseId);
    },
    getNewCollection() {
      const obj = {
        pageIndex: 0,
        saleType: "NEW_COLLECTION"
      };
      this.$store
        .dispatch({
          type: "getSalesListing",
          payload: obj
        })
        .then(({ data }) => {
          this.newCollectionList = data.saleProductDTOs;
          this.$store.commit("saveNewCollection", {
            newCollectionList: this.newCollectionList,
            newCollectionId: 0
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    getCollectiveProduct() {
      const obj = {
        pageIndex: 0,
        saleType: "COLLECTION_FOR_YOU"
      };
      this.$store
        .dispatch({
          type: "getSalesListing",
          payload: obj
        })
        .then(({ data }) => {
          this.collectionList = data.saleProductDTOs;
          this.$store.commit("saveCollectionForYou", {
            collectionList: this.collectionList,
            collectionId: 0
          });
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    if (
      this.$store.getters.nonCarouselBanner &&
      this.$store.getters.nonCarouselBanner.length > 0
    ) {
      this.bannerSaleResponse = this.$store.getters.nonCarouselBanner;
      let categoryProduct =
        this.categoryTreeResponse.length % 2 == 0
          ? this.categoryTreeResponse.length / 2
          : this.categoryTreeResponse.length / 2 + 1;
      let bannerSale = this.bannerSaleResponse.length;
      this.showAlternateDataList = [];
      if (categoryProduct > bannerSale) {
        for (let i = 0; i < categoryProduct; i++) {
          this.showAlternateDataList.push({
            bannerIndex: i,
            evenCategoryIndex: i * 2,
            oddCategoryIndex: i * 2 + 1
          });
        }
      } else {
        for (let i = 0; i < bannerSale - 1; i++) {
          this.showAlternateDataList.push({
            bannerIndex: i,
            evenCategoryIndex: i * 2,
            oddCategoryIndex: i * 2 + 1
          });
        }
      }
    } else {
      this.getBannerSale();
    }
    if (this.$store.getters.nonCarousel1) {
      this.bannerSaleOne = this.$store.getters.nonCarousel1;
    }
    if (this.$store.getters.nonCarousel2) {
      this.bannerSaleTwo = this.$store.getters.nonCarousel2;
    }
    if (
      this.$store.getters.underPriceCategory &&
      this.$store.getters.underPriceCategory.length > 0
    ) {
      this.underPriceCategory1 = this.$store.getters.underPriceCategory[0];
      this.underPriceCategory2 = this.$store.getters.underPriceCategory[1];
    } else {
      this.getUnderPriceCategory();
    }

    if (
      this.$store.getters.categoryTree &&
      this.$store.getters.categoryTree.length > 0
    ) {
      this.categoryTreeResponse = this.$store.getters.categoryTree;
      let categoryProduct =
        this.categoryTreeResponse.length % 2 == 0
          ? this.categoryTreeResponse.length / 2
          : this.categoryTreeResponse.length / 2 + 1;
      let bannerSale = this.bannerSaleResponse.length;
      this.showAlternateDataList = [];
      if (categoryProduct > bannerSale) {
        for (let i = 0; i < categoryProduct; i++) {
          this.showAlternateDataList.push({
            bannerIndex: i,
            evenCategoryIndex: i * 2,
            oddCategoryIndex: i * 2 + 1
          });
        }
      } else {
        for (let i = 0; i < bannerSale - 1; i++) {
          this.showAlternateDataList.push({
            bannerIndex: i,
            evenCategoryIndex: i * 2,
            oddCategoryIndex: i * 2 + 1
          });
        }
      }
    } else {
      this.getCategoriesTree();
    }
    if (
      this.$store.getters.categoriesProductResponses &&
      this.$store.getters.categoriesProductResponses.length > 0
    ) {
      this.categoriesProductResponses = this.$store.getters.categoriesProductResponses;
    } else {
      this.getCategoriesProduct();
    }
    if (
      this.$store.getters.newCollectionList &&
      this.$store.getters.newCollectionList.length > 0
    ) {
      this.newCollectionList = this.$store.getters.newCollectionList;
    } else {
      this.getNewCollection();
    }
    this.getCollectiveProduct();
    if (
      this.$store.getters.trendingProductList &&
      this.$store.getters.trendingProductList.length > 0
    ) {
      this.trendingProductList = this.$store.getters.trendingProductList;
    } else {
      this.getTrendingProducts();
    }
    if (this.$store.getters.merchantId) {
      this.MerchantId = this.$store.getters.merchantId;
    }

    try {
      setTimeout(() => {
        let _self = this;
        window.addEventListener("beforeinstallprompt", e => {
          e.preventDefault();
          if (e) {
            window.Cstmbeforeinstallprompt = e;
            _self.hideAddtoHomeShowJSbridge = true;
          }
        });
      }, 1000);
    } catch (err) {
      console.log(err);
    }
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  async created() {
    const [, , dukaanId] = window.location.pathname.split("/");
    if (dukaanId) {
      try {
        document
          .getElementById("my-manifest-placeholder")
          .setAttribute(
            "href",
            `https://www.mall91.com/dukaan/${dukaanId}/manifest.json`
          );
        this.dukaanUniqueId = dukaanId;
        this.addTohomeImage = require("../assets/images/dukaan91.png");
      } catch (err) {
        console.log(err);
      }
      try {
        let dukaanData;
        await this.$store
          .dispatch({ type: "getDukaanCategory", payload: `${dukaanId}` })
          .then(data => {
            dukaanData = data.data;
          });
        let { scope, scopeCategories, scopeSellers, businessName } = dukaanData;
        this.DukaanbusinessName = businessName;
        if (scopeCategories.length && scopeSellers.length) {
          window.sessionStorage.setItem(
            "scopeCategories",
            scopeCategories.join(",")
          );
          window.sessionStorage.setItem("scopeSellers", scopeSellers.join(","));
          if (["CATEGORIES", "SELLER_CATEGORIES"].includes(scope)) {
            this.$router.onError(err => {
              if (/loading chunk \d* failed./i.test(err.message)) {
                window.location.reload();
              }
            });
            this.$router.push(
              `product-by-category?type=${scope}&categoryid=${scopeCategories[0]}`
            );
          }
        }
      } catch (err) {
        console.log(err);
      }
    }
  },
};
</script>

